module.exports = __webpack_public_path__ + "img/2.e17ed4b4.png";